import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from "framer-motion"
import { GiHotMeal } from 'react-icons/gi'
import tasty from "../images/tasty3.svg"

const Menu = ({ isEng, isFood, products, selectedCat, setSelectedCat, categories }) => {

    
    let lunchMenu = {}
    if (categories) {
       
        lunchMenu = categories[0]
    }
    
    const [hasLunchToday, setHasLunchTOday] = useState(false)

    function filterProducts(prods) {
        if (selectedCat === '') {
            return prods.sort((a, b) =>{
               
                // AKO ISKAME PODREDBA PO DATA
                return a.categories?.importance - b.categories?.importance 
                 // a.publishedAt = new Date(a.publishedAt)
                // b.publishedAt = new Date(b.publishedAt)
                // return b.publishedAt - a.publishedAt 
            } )
        } else {
            let filteredData = []
            for (let prod of prods) {
                if (prod.categories?.title === selectedCat) {
                    if (prod.categories.importance === -1) {
                       
                        let date = new Date(prod.publishedAt)
                        let year = date.getFullYear()
                        let month = date.getMonth() + 1
                        let day = date.getDate()
                        date = year + '.' + month + '.' + day
                        let currentDate = new Date()
                        let yearNow = currentDate.getFullYear()
                        let monthNow = currentDate.getMonth() + 1
                        let dayNow = currentDate.getDate()
                        currentDate = yearNow + '.' + monthNow + '.' + dayNow
                      
                        if (date == currentDate) {
                            prod.publishedAt = new Date(prod.publishedAt)
                            filteredData.push(prod)

                        }
                        // console.log(`${year}.${month}.${day}`)
                        // console.log(currentDate)

                    } else {
                       
                        prod.publishedAt = new Date(prod.publishedAt)
                        filteredData.push(prod)
                    }

                }
            }
               
                let sortedData = filteredData.sort((a,b) => b.publishedAt - a.publishedAt)
               
                return sortedData
        }

    }
    let filteredProducts = []
    if (products !== null) {
        filteredProducts = filterProducts(products)
        
    }
    useEffect(() => {
      
        if (products !== null) {
            for (let eachProd of products) {
                // console.log(eachProd)
                if (eachProd.categories?.importance === -1) {
                    let date = new Date(eachProd.publishedAt)
                    let year = date.getFullYear()
                    let month = date.getMonth() + 1
                    let day = date.getDate()
                    date = year + '.' + month + '.' + day
                    let currentDate = new Date()
                    let yearNow = currentDate.getFullYear()
                    let monthNow = currentDate.getMonth() + 1
                    let dayNow = currentDate.getDate()
                    currentDate = yearNow + '.' + monthNow + '.' + dayNow
                    if (date == currentDate) {
                        setHasLunchTOday(true);
                    }


                }
            }
        }

    }, [products])


    return (
        <>
            <AnimatePresence>
                {isFood && <motion.div
                    initial={{ x: 300, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -300, opacity: 0 }}
                    className='w-full m-auto mb-[80px] text-center '>

                    {/* Category picker */}
                    <div className='w-full flex flex-col flex-wrap gap-y-[0.3rem] -mt-[5px] justify-center  text-lg  font-bold'>
                        
                            {/* <div className='w-full flex  justify-center'>
                                <h1 className=' sm:text-3xl self-center text-2xl font-bold'>{!isEng ? "Изберете категория:" :
                                    "Category:"}
                                </h1>
                            </div>     */}
                     
                       
                        <div className={`flex flex-row  flex-wrap justify-around ${hasLunchToday ? '' : 'mt-3'}`}>
                             {/* ALL AND SPECIAL CATEGORY */}
                             <div className={`w-full flex justify-center m-auto mx-2  ${hasLunchToday ? 'flex' : 'hidden'}` }>
                                {/* <div onClick={() => { setSelectedCat('') }}
                                    className={`cursor-pointer self-center w-3/6 h-[30px] mb-[5px] rounded-md   flex items-center  
                                        justify-center ${selectedCat === '' ? 'bg-blueThree text-greenOne text-lg'
                                            : ' bg-greenOne text-greenTwo'}  text-center italic p-1   text-lg `}>
                                    <p>{!isEng ? 'Всички' : "All"}</p>

                                </div> */}
                                <div onClick={() => { setSelectedCat(categories[0].title) }}
                                    className={`cursor-pointer self-center ml-1 mr-1 mt-2 justify-center w-3/6 h-[30px] mb-[5px] text-center md:justify-center  md:pl-10  rounded-md flex flex-row items-center  
                                    ${selectedCat === (categories ? categories[0].title : "b") ? 'bg-red text-greenOne text-lg' : ' bg-greenOne text-greenTwo'}  
                                    ${hasLunchToday ? 'flex' : 'invisible'}
                                    italic p-1   text-lg `}>
                                    <p className={selectedCat === (categories ? categories[0].title : "b") ? ` text-greenOne ` : `text-red`}>
                                        {!isEng ? categories && categories[0].title : "Lunch menu!"}</p>
                                    <GiHotMeal className={`${selectedCat === (categories ? categories[0]?.title : "b") ? ` text-greenOne` : 'text-red '} ml-2`} size={25} />
                                </div>
                            </div>
                              {/*CATEGORIES MAP ARRAY */}
                            {categories && categories.map((category, i) =>
                                <div
                                    onClick={() => {
                                        setSelectedCat(category.title)
                                    }}
                                    key={category.importance}
                                    className={`cursor-pointer w-1/6 rounded-md mt-1 font-we flex items-center justify-center leading-[1rem]  text-lg h-[40px]
                                    ${category.importance < 0 && 'hidden'}
                                    ${i > 0 && "ml-[1px]"}
                                    ${selectedCat === category.title
                                            ? ' bg-blueThree text-greenOne ' : 'bg-greenOne text-greenTwo'}  text-center italic p-1 `}>
                                    <p>{category.title}</p>
                                </div>)}
                        </div>


                    </div>
                    {/* SHOWCASE */}
                    <div className='w-11/12 m-auto mt-2 sm:flex sm:flex-wrap sm:flex-row '>
                        {/* EACH PRODUCT */}
                         {console.log(filteredProducts)} 
                        {filteredProducts.length === 0 &&
                            <p className='text-blueThree text-xl italic w-1/2 m-auto mt-10'>
                                {!isEng ? "Зареждаме наличните продукти..." : "We are loading..."}
                            </p>}
                        {filteredProducts && filteredProducts.map((product, i) =>
                        
                            <div key={product?.slug?.current}
                                className={`flex flex-col h-[450px] w-full sm:w-1/2  lg:w-1/3 
                        ${(product.categories?.importance === -1 && selectedCat !== categories[0].title) && 'hidden'}`}>
                                <div className='border  border-black border-b-0 h-[320px] border-opacity-60 text-[#2a5d80] overflow-hidden'>
                                    <div className='h-[320px] w-full overflow-hidden  border-black'>
                                        <motion.img
                                            initial={{ scale: 0.7 }}
                                            whileInView={{ scale: 1 }}
                                            whileTap={{ scale: 1.5 }}
                                            whileHover={{ scale: 1.1 }}
                                            transition={{ duration: 0.3 }}
                                            className=' object-contain  w-full p-2 h-full' src={(product.mainImage?.asset?.url 
                                            && product.mainImage?.asset?.url +'?auto=format&w=1200') || tasty}></motion.img>
                                    </div>
                                </div>
                                <div className='border  border-t-0 flex  border-black border-opacity-60 text-blueThree overflow-hidden'>
                                    <div className='z- w-full p-[1px] self-start h-[162px]  text-md flex justify-around items-center'>
                                        <div className='w-9/12 flex flex-col'>
                                            <h1 className='text-2xl leading-[2rem]'>{product.title} - {product.weight &&
                                                ` ${product.weight}`}{!isEng ? "гр." : "gr."}</h1>
                                            <div className='prose flex flex-col italic  items-center  text-xl'>
                                                <p className='text-blueThree '>{!isEng ? "Описание:" : "Description:"}</p>
                                                <div className='mb-4 leading-[1rem]'>
                                                    <p>{!isEng ? product.body : product.body_eng}</p>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='h-[60px] w-[60px] mr-2 border border-[#2a5d80] rounded-full bg-greenOne flex flex-col justify-center items-center'>
                                            <p>{(product.price / 1.95583).toFixed(2)}€</p>
                                            {/* <p>{product.price}{!isEng ? "лв." : "bgn."}</p> */}
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='mt-6 text-2xl italic pb-4 text-greenTwo'>
                        {filteredProducts.length !== 0
                            &&
                            <h1>{!isEng ? "Достигнахте до края на тази категория." : "You reached the end of this category"}</h1>}
                    </div>


                </motion.div>}
            </AnimatePresence>
        </>
    )
}

export default Menu